import * as bucket from "@omegagrid/bucket";
import * as calendar from "@omegagrid/calendar";
import * as dashboard from "@omegagrid/dashboard";
import * as code from "@omegagrid/code";
import * as commands from "@omegagrid/commands";
import * as core from "@omegagrid/core";
import * as dialog from "@omegagrid/dialog";
import * as editor from "@omegagrid/editor";
import * as form from "@omegagrid/form";
import * as grid from "@omegagrid/grid";
import * as markdown from "@omegagrid/markdown";
import * as statusbar from "@omegagrid/statusbar";
import * as tabs from "@omegagrid/tabs";
import * as toolbar from "@omegagrid/toolbar";
import * as tree from "@omegagrid/tree";
import * as xlsx from "@omegagrid/plugin-xlsx";
import * as charts from "@omegagrid/plugin-charts";

/**
 * The whole component library under one namespace, exposed by the app shells as
 * window.Omegagrid for extension authors. Deliberately kept out of the package
 * index: importing it drags every omegagrid package into the bundle, which the
 * standalone extension page must not pay for.
 */
export const Omegagrid = {
	bucket,
	calendar,
	code,
	commands,
	core,
	dashboard,
	dialog,
	editor,
	form,
	markdown,
	grid,
	statusbar,
	tabs,
	toolbar,
	tree,
	plugins: { xlsx, charts }
};
